import React from "react";
import OperatorRequestDetails from "./OperatorRequestDetails";

const OapiDetails = () => <OperatorRequestDetails />;

export default OapiDetails;
